<template>
    <slider v-if="length > 0" :items="items" :config="config" class="feed-widget">
        <template v-slot:body="{ item, index }">
            <slot name="body" :item="item" :index="index" />
        </template>
        <template v-slot:navigation v-if="items.length > 1">
            <slot name="navigation" />
        </template>
    </slider>
</template>
<script>
    import Slider from '../Slider';
    import AjaxCaller from '../../mixins/AjaxCaller';
    export default {
        mixins: [AjaxCaller],
        components: { Slider },
        props: {
            config: {
                type: Object,
                default: () => { return {} }
            }
        },
        data() {
            return {
                items: [],
                length: 0,
            }
        },
        mounted() {
            this.makeCall(this.success, this.failure);
        },
        methods: {
            success(response) {
                if (!response.data.records) {
                    return;
                }
                this.items = response.data.records;
                this.length = this.items.length;
            },
            failure(error) {
                this.stopProcessing();
                console.log(error);
            }
        }
    }
</script>